import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { getCountryCode } from '../../redux/config'
import { Icon } from '../Icons'
import { Space } from '../Space'
import { Title } from '../Text'
import { themeSpace } from '../theme'
import { CompanyLink } from '../CompanyLink/CompanyLink'

const StyledHeader = styled.div<{ hasBorderBottom: boolean }>`
  color: ${p => p.theme.colors.primary};
  padding: ${themeSpace(2)};
  border-bottom: ${({ hasBorderBottom, theme }) =>
    hasBorderBottom ? `1px solid ${theme.colors['borderPrimary']}` : 'none'};
`

type Props = {
  hasBorderBottom: boolean
  companyIdentifier: string
  companyName: string
  companyIdentifierType: string | undefined
}

const StyledOutlined = styled(Icon)`
  padding-left: ${themeSpace(2)};
`

export const SearchResultItemHeader = ({
  hasBorderBottom,
  companyIdentifier,
  companyName,
  companyIdentifierType
}: Props) => {
  const domainCode: string = useSelector(getCountryCode)
  const location = useLocation()

  return (
    <StyledHeader hasBorderBottom={hasBorderBottom}>
      <CompanyLink
        companyIdentifier={companyIdentifier}
        companyName={companyName}
        companyIdentifierType={companyIdentifierType!}
        domainCode={domainCode}
        previousLocation={location.pathname}
      >
        <Title level="medium">
          <Space className="qa--search-result-company-name" space={1} alignItems="center">
            <span>
              {companyName}
              <StyledOutlined type="RightOutlined" />
            </span>
          </Space>
        </Title>
      </CompanyLink>
    </StyledHeader>
  )
}
